export default "__VITE_ASSET__DID34Xbr__"